import { create } from 'zustand';

const useSearchDocumentStore = create((set) => ({
    searchInput: '', // Initial state
    setSearchInput: (value) => set({ searchInput: value }), // Function to update checked state
}));

export default useSearchDocumentStore;
